import {inject, Injectable} from '@angular/core';
import {CartStore} from '@features/sales/application/store/cart/cart.store';
import {CartItemDTO} from '@features/sales/domain/models/cart/cart-item.model';
import {Cart} from "@features/sales/domain/entities/cart/cart.entity";

@Injectable({providedIn: 'root'})
export class CartCommandService {
  private readonly cart = inject(CartStore);

  lock(): void {
    this.cart.setLocked(true);
  }

  unlock(): void {
    this.cart.setLocked(false);
  }

  clear(): void {
    this.cart.reset();
  }

  setItems(items: CartItemDTO[]): void {
    this.cart.setItems(items);
  }

  apply(cart: Cart): void {
    this.setItems(cart.toDTOs());
  }
}
